import React, { useState, useEffect } from "react";
import validator from "validator";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loader from "./Loader";
import axios from "axios";
import { useUserStore } from "../store/UserStore";
import { useFormStep } from "../store/FormStepStore";
import {
  base,
  confirm_cmris_user_email,
  confirm_token,
  change_password,
} from "../constants/urls";
import { useAuth } from "../store/Auth";
import sendToken from "./sendToken";

export default function PasswordReset() {
  const [isLoading, setIsLoading] = useState(false);

  const userDetails = useUserStore((state) => state.userDetails);
  const setUserInfo = useUserStore((state) => state.setUserDetails);
  const setAuth = useAuth((state) => state.setAuth);
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [username, setUserName] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [c_password, setConfirmPassword] = useState("");
  const [isResending, setIsResending] = useState(false);
  
  // TIMER STATE
  const [resendTimer, setResendTimer] = useState(0);

  // COUNTDOWN EFFECT
  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const ConfirmToken = (e) => {
    // Note: handleSubmit passes data, but keeping your logic structure
    setIsLoading(true);
    let confirmTokenUrl = base + confirm_token + phone + "/" + token;
    if (!validator.isURL(confirmTokenUrl)) {
      setIsLoading(false);
      return;
    }
    axios({
      method: "get",
      url: confirmTokenUrl,
    }).then((response) => {
      if (response.status === 200) {
        if (response.data.statusCode === 0) {
          setIsLoading(false);
          Swal.fire({
            title: "Success!",
            text: "Token Confirmed",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#1C89DE",
          }).then(() => {
            setStep(3);
          });
        } else {
          setIsLoading(false);
          Swal.fire({
            title: "Error!",
            text: "Token Confirmation failed",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#1C89DE",
          });
        }
      } else {
        setIsLoading(false);
        Swal.fire({
          title: "Error!",
          text: "Error Confirming Token. Please Regenerate.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1C89DE",
        });
      }
    });
  };

  const ChangePassword = (e) => {
    if (password !== c_password) {
      Swal.fire({
        title: "Error!",
        text: "Password must match.",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
      return;
    }
    const url = base + change_password;
    let data = {
      password: password,
      c_password: c_password,
      phone: phone,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resJson) => {
        if (resJson.statusCode === 0) {
          Swal.fire({
            title: "Success!",
            text: "Password Set.",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#1C89DE",
          }).then(() => {
            window.location = "/login";
          });
        }
      });
  };

  const ConfirmEmail = (e) => {
    let login_url = base + confirm_cmris_user_email + username;
    setIsLoading(true);
    if (username === undefined || username === "") {
      Swal.fire({
        title: "Error!",
        text: "Please input your email or phone number",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
      setIsLoading(false);
      return;
    }

    fetch(login_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(function (res) {
        if (res.status === 200) {
          return res.json();
        }
      })
      .then(function (data) {
        if (data.statusCode === 0) {
          if (data.data.email !== "" && data.data.phone !== "") {
            setPhone(data.data.phone);
            setEmail(data.data.email);
            sendToken("sms", data.data.phone, data.data.email);
          } else if (data.data.email === "" && data.data.phone !== "") {
            setPhone(data.data.phone);
            sendToken("sms", data.data.phone, "none@none.com");
          } else {
            setEmail(data.data.email);
            sendToken("email", data.data.email);
          }
          setStep(2);
          setResendTimer(60); // START 60s TIMER
          setIsLoading(false);
        } else {
          Swal.fire({
            title: "Error!",
            text: "Profile with " + username + " not registered",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#1C89DE",
          }).then(() => {
            setIsLoading(false);
          });
        }
      });
  };

  const ResendToken = async (e) => {
    e.preventDefault();
    if (resendTimer > 0) return;

    setIsResending(true);
    try {
      let result;
      if (phone !== "" && email !== "") {
        result = await sendToken("sms", phone, email);
      } else if (phone !== "" && email === "") {
        result = await sendToken("sms", phone, "none@none.com");
      } else {
        result = await sendToken("email", email);
      }

      if (result) {
        Swal.fire({
          title: "Success!",
          text: "Token has been resent successfully",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1C89DE",
        });
        setResendTimer(60); // RESET TIMER TO 60s
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to resend token. Please try again.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1C89DE",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "An error occurred while resending token.",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div>
      <div className="text-2xl pt-4 pb-4 bg-blue-200 font-bold text-center">
        MOTOR VEHICLE INFORMATION PORTAL
      </div>
      <div className="lg:flex pt-8 bg-gray-100">
        <div className={`xl:flex-initial xl:w-2/6`}></div>
        <div className={`xl:flex-1 xl:px-1 xl:w-4/6 mx-4`}>
          <form onSubmit={(e) => e.preventDefault()}>
            <div>
              <div className="text-center text-2xl font-bold">
                Reset/Create Password
              </div>
              
              {step === 1 && (
                <>
                  <label htmlFor="email" className="block text-gray-900 text-lg mt-3">
                    Email Address or Phone Number
                    <span className="text-red-500 text-lg"> *</span>
                  </label>
                  <input
                    type="text"
                    {...register("username", { required: true })}
                    onChange={(e) => setUserName(e.target.value)}
                    className="w-full mb-4 bg-white rounded-lg h-10 text-xl mt-1 text-gray-800 leading-loose py-1 px-2 border border-gray-600"
                  />
                  <button
                    onClick={(e) => handleSubmit(ConfirmEmail(e))}
                    className="bg-blue-500 w-full py-2 font-bold mt-2 rounded-lg text-gray-100 text-lg"
                  >
                    Continue
                    {isLoading && <Loader />}
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="mt-4 text-gray-700 italic">
                    A token was sent to {phone || ""} {phone && email ? "AND" : ""} {email || ""}
                  </div>
                  <label htmlFor="token" className="block text-gray-900 text-lg mt-3">
                    Token
                    <span className="text-red-500 text-lg"> *</span>
                  </label>
                  <input
                    type="text"
                    {...register("token", { required: true })}
                    onChange={(e) => setToken(e.target.value)}
                    className="w-full mb-4 bg-white rounded-lg h-10 text-xl mt-1 text-gray-800 leading-loose py-1 px-2 border border-gray-600"
                  />
                  <button
                    onClick={(e) => handleSubmit(ConfirmToken(e))}
                    className="bg-blue-500 w-full py-2 font-bold mt-2 rounded-lg text-gray-100 text-lg"
                  >
                    Confirm Token
                    {isLoading && <Loader />}
                  </button>

                  {/* REPOSITIONED RESEND SECTION WITH COUNTDOWN */}
                  <div className="mt-8 border-t pt-4 text-center">
                    <p className="text-gray-500 text-sm mb-2">Didn't receive the token?</p>
                    {resendTimer > 0 ? (
                      <div className="text-gray-400 font-bold text-lg">
                        Resend available in <span className="text-blue-500">{resendTimer}s</span>
                      </div>
                    ) : (
                      <button
                        onClick={ResendToken}
                        disabled={isResending}
                        className="text-blue-600 font-bold text-lg underline hover:text-blue-800"
                      >
                        {isResending ? "Resending..." : "Resend Token Now"}
                        {isResending && <Loader />}
                      </button>
                    )}
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <label htmlFor="password" className="block text-gray-900 text-lg mt-3">
                    Password
                    <span className="text-red-500 text-lg"> *</span>
                  </label>
                  <input
                    type="password"
                    {...register("password", { required: true })}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full mb-4 bg-white rounded-lg h-10 text-xl mt-1 text-gray-800 py-1 px-2 border border-gray-600"
                  />

                  <label htmlFor="confirm_password" className="block text-gray-900 text-lg">
                    Confirm Password
                    <span className="text-red-500 text-lg"> *</span>
                  </label>
                  <input
                    type="password"
                    {...register("confirm_password", { required: true })}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full mb-4 bg-white rounded-lg h-10 text-xl mt-1 text-gray-800 py-1 px-2 border border-gray-600"
                  />
                  <button
                    onClick={(e) => handleSubmit(ChangePassword(e))}
                    className="bg-blue-500 w-full py-2 font-bold mt-2 rounded-lg text-gray-100 text-lg"
                  >
                    Change Password
                    {isLoading && <Loader />}
                  </button>
                </>
              )}
            </div>
          </form>
        </div>
        <div className={`xl:flex-initial xl:w-2/6`}></div>
      </div>
    </div>
  );
}